<div class="headline-container">
  <div class="headline-content">
    <div class="account-status">
      @if (!headerData.IsHeadline) {
        <h1 class="headline h1-lg">{{ headerData.Message }}</h1>
      } @else {
        <div class="headline" [innerHTML]="headerData.Message | safe: 'SafeHtml'"></div>
        @if (headerData.RedirectURL) {
          @if (headerData.RedirectURL.includes("https://signup.gassouth.com/")) {
            <div class="cta-container">
              <a
                [attr.aria-label]="headerData.ButtonAriaLabel"
                role="link"
                class="gs-link-btn"
                [href]="headerData.RedirectURL"
                [innerHTML]="headerData.ButtonLabel"
              ></a>
            </div>
          } @else {
            <div class="cta-container">
              <a
                [attr.aria-label]="headerData.ButtonAriaLabel"
                role="link"
                class="gs-link-btn"
                [routerLink]="[headerData.RedirectURL]"
                [innerHTML]="headerData.ButtonLabel"
              ></a>
            </div>
          }
        }
      }
    </div>
    @if (headerData.ShowAccountInfo && loginRes) {
      <div class="account-info">
        <p><b>Account Number: </b>{{ loginRes.Accounts[0].AccountNumber }}</p>
        @if (loginRes.Accounts[0].NumAgreements === 1) {
          <p class="header-address">{{ loginRes.Accounts[0].ServiceAddresses[0].Address1 | titlecase }}</p>
          @if (loginRes.TotalNumAccounts == 1) {
            <p class="header-address acct-address">
              {{ loginRes.Accounts[0].ServiceAddresses[0].City | titlecase }}
              {{ loginRes.Accounts[0].ServiceAddresses[0].State | titlecase }},
              {{ loginRes.Accounts[0].ServiceAddresses[0].PostalCode }}
            </p>
          }
        }
        @if (loginRes.TotalNumAccounts > 1) {
          <a routerLink="/multiaccount-summary">View All Accounts</a>
        }
      </div>
    }
  </div>
</div>
